module.exports = __webpack_public_path__ + "static/media/notification.d7241ff2.mp3";